export default __webpack_public_path__ + "static/media/create_task.75b0a613.png";